import React from "react";
import { Route, useRouteMatch } from "react-router-dom";
import AudioPage from "./Audio CMS/AudioPage";
import SeriesPage from './Series/SeriesInventoryRouter'
import TinyUrlPage from './TinyUrl/TinyUrlRouter'
import RedirectsPage from './Redirects/RedirectsRouter'
import AffinityGroupsPage from './AffinityGroups/AffinityGroupsRouter'
import ContentSummariesRouter from "./ContentSummaries/ContentSummariesRouter";

const ContentFeaturePage = () => {
    let { path } = useRouteMatch();

    return (
        <div>
            <Route path={`${path}/audio`}>
                <AudioPage />
            </Route>
            <Route path={`${path}/series`}>
                <SeriesPage />
            </Route>
            <Route path={`${path}/tinyurls`}>
                <TinyUrlPage />
            </Route>
            <Route path={`${path}/redirects`}>
                <RedirectsPage />
            </Route>
            <Route path={`${path}/affinitygroups`}>
                <AffinityGroupsPage />
            </Route>
            <Route path={`${path}/summaries`}>
                <ContentSummariesRouter />
            </Route>
        </div>
    );
};

export default ContentFeaturePage;
